$ = jQuery.noConflict();
import anime from 'animejs'

const menuAnimation = () => {

    // reveal animation
    
    $('.c-header__menu-toggle').on('click', function(e) {
      
      e.preventDefault()

      const menu = $(this).data('toggle-visibility')

      $('#' + menu).show();

      $('#menu .c-links__item, .c-menu__header, .js-fade__menu-footer, #menu .c-menu__logo, .c-outer .o-media--vertical, .c-outer .o-media--menu, .c-icon--redcross btn').css('opacity', '0') 

      $('#' + menu).addClass('menu-open')

      const slidefromRight = anime({
        targets: '.c-inner',
  
        translateX: {
          value: [ '100%', 0 ],
          duration: 400, 
          easing: 'easeInOutQuint',
          delay: 0,
        },
        backgroundColor: ["#eeeeee", "#ffffff"],
        loop: false

      });

      function slideInLeftSide() {

        anime({

          targets: '.c-outer',    
          translateX: {
            value: [ '100%', 0 ],
            duration: 400, 
            easing: 'easeInOutQuint',
            delay: 0,
          },
          backgroundColor: ["#be2c26", "#f9423a"],
          loop: false

        })
      }

      slideInLeftSide()

      const fadeInMenuLists = anime({
        targets: '#menu .c-links__item',

        opacity: {
          value: 1,
          duration: 600,
          easing: 'easeOutCubic',
          delay: function(el, i, l) { return i * 150; }
        },
        loop: false

      });

      const fadeInMenuHeader = anime({
        targets: '.c-menu__content .c-icon--redcross, .c-menu__header',

        opacity: {
          value: 1,
          duration: 300,
          easing: 'easeInOutQuint',
          delay: 50,
        },
        loop: false

      });

      const fadeInLeftSide = anime({
        targets: '.c-menu__logo, .c-outer .o-media--vertical, .c-outer .o-media--menu',

        opacity: {
          value: 1,
          duration: 300,
          easing: 'easeInOutQuint',
          delay: 100,
        },
        loop: false

      });

      const fadeInMenuFooter = anime({
        targets: '.js-fade__menu-footer',

        opacity: {
          value: 1,
          duration: 600, 
          easing: 'easeInOutQuint',
          delay: function(el, i, l) { return i * 150; }
        },
        loop: false

      });

    })

    // reverse animation

    $('.btn.c-icon--redcross').on('click', function(e) {
      e.preventDefault() 

      const menu = $(this).data('toggle-visibility')

      $('[data-toggle-visibility]').find($('#').data('toggle-visibility')).slideUp()

      $('#' + menu).removeClass('menu-open')

      const slideToRight = anime({
        targets: '.c-inner',
  
        translateX: {
          value: [ 0, '100%'],
          duration: 400, 
          easing: 'easeInOutQuint',
          delay: 0,
        },

        backgroundColor: ["#ffffff", "#eeeeee"],

      });

      function slideOutLeftSide() {

        anime({
          targets: '.c-outer',
          translateX: {
            value: [ 0, '100%' ],
            duration: 400, 
            easing: 'easeInOutQuint',
            delay: 0,
          },
          backgroundColor: ["#f9423a", "#be2c26"],
          duration: 400,
          easing: 'easeInOutQuint',
          loop: false
        })
      }

      slideOutLeftSide()

      const fadeOutLeftSide = anime({
        targets: '.c-menu__logo, .c-outer .o-media--vertical, .c-menu__content .c-icon--redcross, .c-outer .o-media--menu',

        opacity: {
          value: 0,
          duration: 300,
          easing: 'easeInOutQuint',
          delay: 0,
        },
        loop: false

      });

      const fadeOutMenuLists = anime({
        targets: '#menu .c-links__item',

        opacity: {
          value: 0,
          duration: 400,
          easing: 'easeInOutQuint',
          delay: function(el, i, l) { return i * 50; }
        },
        loop: false

      });

      const fadeOutMenuHeader = anime({
        targets: '.c-menu__header',

        opacity: {
          value: 0,
          duration: 400,
          easing: 'easeInOutQuint',
          delay: 300,
        },
        loop: false,
        complete (anim) {
          $('#' + menu).hide();
        }

      });

      const fadeOutMenuFooter = anime({
        targets: '.js-fade__menu-footer',

        opacity: {
          value: 0,
          duration: 400,
          easing: 'easeInOutQuint',
          delay: function(el, i, l) { return i * 50; }
        },
        loop: false

      });

    })

  }

  export default menuAnimation